module.exports = __webpack_public_path__ + "static/media/37.fde065b5.mp3";